import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';

interface TabsContainerProps {
  children: React.ReactNode;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    overflowX: 'auto',
    width: '100%',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100vw',
    },
  },
}));

const TabsContainer = ({ children }: TabsContainerProps) => {
  const classes = useStyles();

  return <div className={classes.root}>{children}</div>;
};

export default TabsContainer;
